module.exports = __webpack_public_path__ + "img/sazman.c231a79.svg";